interface IKVP_FORMULA {
  amount: number;
}
export const KVP_FORMULA = ({ amount }: IKVP_FORMULA) => {
  if (amount < 1e3 || amount > 1e6) {
    const emptyRes = 0;
    return {
      matureAmount: emptyRes.toFixed(2),
    };
  }
  const investmentAmount = amount;
  const maturityAmount = investmentAmount * 2;
  return {
    matureAmount: maturityAmount.toFixed(2),
  };
};
